import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-request-access-read-steps',
  templateUrl: './request-access-read-steps.component.html',
  styleUrls: ['./request-access-read-steps.component.scss']
})
export class RequestAccessReadStepsComponent implements OnInit {

  sectionTitle = 'Request Access'
  RAInfo = {
    unlock: "If you have been granted future accesst someone's plan, you can request for it to be unlocked following their death or incapacitation.",
    titleSteps: 'Please read the steps below'
  }
  RACardSteps = [
    {
      cardCircle: 1,
      cardTitle: 'Notify',
      cardText: 'This is a longer card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.'
    },
    {
      cardCircle: 9,
      cardTitle: 'Verify',
      cardText: 'This card has supporting text below as a natural lead-in to additional content.'
    },
    {
      cardCircle: 10,
      cardTitle: 'Unlock',
      cardText: 'This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.'
    }
  ]

  constructor() { }

  ngOnInit() {
  }

}
